import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { PHONE_ONLY_COUNTRIES, PHONE_PREFERRED_COUNTRIES } from '../../assets/appConstants';

const PhoneInputWrapper = ({ countryCode, phoneOrEmail, onInputChange, placeholder }) => {
  return (
    <div className="phone-input-wrapper">
      <PhoneInput
        style={{ height: '40px', width: '300px' }}
        country={countryCode}
        value={phoneOrEmail}
        preferredCountries={PHONE_PREFERRED_COUNTRIES}
        onChange={onInputChange}
        onlyCountries={PHONE_ONLY_COUNTRIES}
        countryCodeEditable={false}
        enableSearch
        disableSearchIcon
        disableInitialCountryGuess={false}
        placeholder={placeholder || ""}
      />
    </div>
  );
};

export default PhoneInputWrapper;
